<template>
  <div class="trabalhos">
    <Container>
      <h1>
        Uma equipe criativa e talentosa ajudando marcas a atingirem todo seu
        potencial.
      </h1>
      <FilterButton />
    </Container>
    <TagList />
    <WorkList />
  </div>
</template>

<script>
import Container from "@/components/Container";
import FilterButton from "@/components/FilterButton";
import TagList from "@/sections/TagList";
import WorkList from "@/sections/WorkList";

export default {
  name: "trabalhos",
  components: {
    Container,
    TagList,
    WorkList,
    FilterButton
  },
  head: {
    title: {
      inner: "Branding, site, campanhas online e offline "
    },

    meta: [
      {
        name: "description",
        content:
          "Uma agência supercriativa com cases incríveis. Confira alguns dos trabalhos executados pela nossa equipe e traga o seu projeto para a Magor!",
        id: "desc"
      },
      {
        name: "og:description",
        content:
          "Uma agência supercriativa com cases incríveis. Confira alguns dos trabalhos executados pela nossa equipe e traga o seu projeto para a Magor!",
        id: "ogdesc"
      },
      {
        name: "keywords",
        content:
          "magor, design, gráfico, digital, propaganda, marketing, talento"
      }
    ]
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/vars";
h1 {
  font-weight: 900;
  font-size: 5rem;
  line-height: 6rem;
  margin-bottom: 4.7rem;
  @media (max-width: $max-sm) {
    font-size: 1.8rem;
    line-height: 2.3rem;
    margin-bottom: 3.4rem;
  }
}

.trabalhos {
  padding-top: 11.5rem;

  @media (max-width: $max-sm) {
    padding-top: 1rem;
  }
}
</style>
